import React from 'react'
import { useFeedbackWorkflow } from './FeedbackWorkflowContext'
import { FileProp } from './GeneralFeedbackContent'
import { deleteSvg, fileSvg, screenshotSvg } from "../../../../components/FeedbackOverview/SVG";

const ImageInput = ({
    screenshot,
    setIsVisible,
    isVisible,
    onStartCapture,
    file,
    inputRef,
    setFile,
    setScreenshot,
    feedbackType
}: {
    screenshot: FileProp | null | undefined,
    setIsVisible: Function | undefined,
    isVisible: boolean | undefined,
    onStartCapture: () => void,
    file: FileProp | null,
    inputRef: React.MutableRefObject<HTMLInputElement | null>,
    setFile: (file: FileProp | null) => any;
    setScreenshot: ((screenshot: FileProp | null) => void) | undefined,
    feedbackType: string
}) => {
    const { themeManager } = useFeedbackWorkflow();

    return (
        <div className='q-fdov-image-input q-gen-img-upl'>
            <div className="q-gen-img-upl-btns">
                <div className="gen-upl-btn-1">
                    <button
                        style={{
                            border: themeManager.getGeneralFeedbackInputStyle(feedbackType).border || "1px solid #ECECEC",
                            opacity: screenshot === null ? 1 : 0.5,
                        }}
                        disabled={screenshot !== null}
                        onClick={() => {
                            setIsVisible && setIsVisible(!isVisible);
                            onStartCapture();
                        }}
                    >
                        {screenshotSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                    </button>
                </div>

                <div className="gen-upl-btn-2">
                    <div style={{
                        border: themeManager.getGeneralFeedbackInputStyle(feedbackType).border || "1px solid #ECECEC",
                        opacity: file === null ? 1 : 0.5,
                    }}
                    >
                        <label className="q-button-sm q-fw-normal " htmlFor="feed-back-up-img" style={{
                            cursor: file === null ? "pointer" : "no-drop",
                        }}>
                            {fileSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                        </label>
                        <input type="file" style={{
                            display: "none"
                        }} ref={inputRef} onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                                const selectedFile = e.target.files[0];
                                setFile(selectedFile);
                            }
                        }} disabled={file !== null} accept='image/*' id="feed-back-up-img" />
                    </div>
                </div>
            </div>
            {screenshot !== null &&
                (
                    <div className="q-fdov-file-name q-gen-screen-shot-name"
                        style={{
                            border: themeManager.getGeneralFeedbackInputStyle(feedbackType).border || "1px solid #ECECEC",
                        }}
                    >
                        <div>
                            {screenshotSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                        </div>
                        <p style={{
                            color: themeManager.getGeneralFeedbackInputFormColor()
                        }}>
                            {screenshot && screenshot.name}
                        </p>
                        <button onClick={() => {
                            setScreenshot && setScreenshot(null)
                        }}>
                            {deleteSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                        </button>
                    </div>
                )}
            {
                file && (
                    <div className="q-fdov-file-name q-gen-file-name"
                        style={{
                            border: themeManager.getGeneralFeedbackInputStyle(feedbackType).border || "1px solid #ECECEC",
                        }}
                    >
                        <div>
                            {fileSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                        </div>
                        <p style={{
                            color: themeManager.getGeneralFeedbackInputFormColor()
                        }}>
                            {file.name}
                        </p>
                        <button
                            onClick={() => {
                                setFile(null);
                                if (inputRef.current) {
                                    inputRef.current.value = "";
                                }
                            }}>
                            {deleteSvg(themeManager.getGeneralFeedbackPrimaryButtonStyle(feedbackType).color)}
                        </button>
                    </div>
                )
            }
        </div>
    )
}

export default ImageInput